import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/vendorsActions'
import * as api from '../api/vendor'

import { message } from 'antd'

function* fetchVendors(action) {
  try {
    const payload = yield call(api.getVendorsList, action)
    yield put({ type: constants.VENDORS_MODULE_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.VENDORS_MODULE_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* vendorsRefresh() {
  yield takeLatest(constants.VENDORS_MODULE_REFRESH.ACTION, fetchVendors)
}

function* sagaCreateNewVendor(action) {
  try {
    const payload = {
      vendor_data: {
        type: 'Vendor',
        name: action.vendor.name,
        work_number: action.vendor.work_number_add,
        fax_number: action.vendor.fax_number,
        vendor: action.vendor.name,
        address1: action.vendor.address1,
        address2: action.vendor.address2,
        city: action.vendor.city,
        state: action.vendor.state,
        zip: action.vendor.zip
      },
      user_id: action.userId
    }

    yield call(api.createNewVendor, payload)
    yield put({ type: constants.CREATE_NEW_VENDOR.SUCCESS, payload })
    yield call(fetchVendors)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNewVendor() {
  yield takeLatest(constants.CREATE_NEW_VENDOR.ACTION, sagaCreateNewVendor)
}

function* sagaUpdateSavedVendor(action) {
  try {
    const payload = {
      company: {
        category_id: action.company.categoryId,
        name: action.company.name,
        description: action.company.description,
        work_number: action.company.work_number_edit,
        fax_number: action.company.fax_number,
        internal_description: action.company.internal_description,
        type: 'Vendor',
        cost: action.company.cost,
        overhead: action.company.overhead,
        markup: action.company.markup,
        tax: action.company.tax,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      company_id: action.companyId
    }
    yield call(api.updateSavedVendor, payload)
    yield put({ type: constants.UPDATE_SAVED_VENDOR.SUCCESS, payload })
    yield call(fetchVendors)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_SAVED_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateSavedVendor() {
  yield takeLatest(constants.UPDATE_SAVED_VENDOR.ACTION, sagaUpdateSavedVendor)
}

function* sagaDeleteVendor(action) {
  try {
    const payload = {
      company_id: action.companyId
    }
    yield call(api.deleteVendor, payload)
    yield put({ type: constants.DELETE_VENDOR.SUCCESS, payload })
    yield call(fetchVendors)
    message.success('Vendor deleted.')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error('Unable to delete this Vendor as it is being used elsewhere.')
    yield put({
      type: constants.DELETE_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVendor() {
  yield takeLatest(constants.DELETE_VENDOR.ACTION, sagaDeleteVendor)
}

// notes
function* fetchVendorNote(action) {
  try {
    const payload = yield call(api.fetchVendorNote, { vendorId: action.vendorId })
    yield put({ type: constants.GET_VENDOR_NOTE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VENDOR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchVendorNote() {
  yield takeLatest(constants.GET_VENDOR_NOTE.ACTION, fetchVendorNote)
}

function* createVendorNote(action) {
  try {
    const payload = {
      content: action.content,
      vendorId: action.vendorId
    }
    yield call(api.createVendorNote, payload)
    yield put({ type: constants.CREATE_VENDOR_NOTE.SUCCESS, payload })
    yield call(fetchVendorNote, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_VENDOR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateVendorNote() {
  yield takeLatest(constants.CREATE_VENDOR_NOTE.ACTION, createVendorNote)
}

function* editVendorNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editVendorNote, payload)
    yield put({ type: constants.EDIT_VENDOR_NOTE.SUCCESS, payload })
    yield call(fetchVendorNote, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_VENDOR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditVendorNote() {
  yield takeLatest(constants.EDIT_VENDOR_NOTE.ACTION, editVendorNote)
}

function* deleteVendorNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteVendorNote, payload)
    yield put({ type: constants.DELETE_VENDOR_NOTE.SUCCESS, payload })
    yield call(fetchVendorNote, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VENDOR_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVendorNote() {
  yield takeLatest(constants.DELETE_VENDOR_NOTE.ACTION, deleteVendorNote)
}

// ATTACHMENT SAGAS
function* uploadVendorAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      vendorId: action.vendorId
    }

    yield call(api.uploadVendorAttachments, payload)
    yield put({ type: constants.UPLOAD_VENDOR_ATTACHMENT.SUCCESS, payload })
    yield call(getVendorAttachments, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_VENDOR_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadVendorAttachments() {
  yield takeLatest(constants.UPLOAD_VENDOR_ATTACHMENT.ACTION, uploadVendorAttachments)
}

function* getVendorAttachments(action) {
  try {
    const payload = yield call(api.getVendorAttachments, action.vendorId)
    yield put({ type: constants.GET_VENDOR_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VENDOR_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetVendorAttachments() {
  yield takeLatest(constants.GET_VENDOR_ATTACHMENTS.ACTION, getVendorAttachments)
}

function* updateVendorAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_VENDOR_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getVendorAttachments, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_VENDOR_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateVendorAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_VENDOR_ATTACHMENT_DESCRIPTION.ACTION,
    updateVendorAttachmentDescription
  )
}

function* deleteVendorAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      vendorId: action.vendorId
    }

    yield call(api.deleteVendorAttachment, payload)
    yield put({ type: constants.DELETE_VENDOR_ATTACHMENT.SUCCESS, payload })
    yield call(getVendorAttachments, { vendorId: action.vendorId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_VENDOR_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteVendorAttachments() {
  yield takeLatest(constants.DELETE_VENDOR_ATTACHMENT.ACTION, deleteVendorAttachment)
}

export function* rootSaga() {
  yield all([
    fork(vendorsRefresh),
    fork(watchCreateNewVendor),
    fork(watchUpdateSavedVendor),
    fork(watchDeleteVendor),

    //notes
    fork(watchFetchVendorNote),
    fork(watchCreateVendorNote),
    fork(watchEditVendorNote),
    fork(watchDeleteVendorNote),

    // attachments
    fork(watchUploadVendorAttachments),
    fork(watchGetVendorAttachments),
    fork(watchUpdateVendorAttachmentDescription),
    fork(watchDeleteVendorAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/vendorsSaga.js